// App-wide notifications. Replaces window.alert with non-blocking toasts that
// match the app's look; the <Toaster> lives in App.js.
import toast from 'react-hot-toast';

export const notify = {
  success: (message) => toast.success(message),
  error: (message) => toast.error(message),
  // Validation nudges ("fill in X"): neutral tone, no red
  warn: (message) => toast(message, { icon: '⚠️' }),
  info: (message) => toast(message),
};
